/** Query keys the jobs list filter writes, in the URL and in storage. */
export const PROJECT_FILTER_QUERY_KEYS = [
  'jobsTab',
  'teamIds',
  'locations',
  'status',
  'source',
  'copilot',
  'titleOrReqId',
] as const;

/** Still read from an old link but never written, so no page keeps them for the jobs filter. */
export const LEGACY_PROJECT_FILTER_QUERY_KEYS = ['location'] as const;
